import Vue from 'vue';
import { forIn, snakeCase, isNil } from 'lodash';
import { ls } from 'services';

const getStoreKey = (globalKey, key) => `${snakeCase(globalKey)}_${snakeCase(key)}`;

const LocalStoreOptions = {

  setByKey(globalKey, key, value) {
    const storeKey = getStoreKey(globalKey, key);
    if (!isNil(value)) ls.set(storeKey, value);
  },

  getByKey(globalKey, key) {
    const storeKey = getStoreKey(globalKey, key);
    return ls.get(storeKey);
  },

  removeByKey(globalKey, key) {
    const storeKey = getStoreKey(globalKey, key);
    ls.remove(storeKey);
  },

  set(globalKey, options) {
    forIn(options, (value, key) => {
      const storeKey = getStoreKey(globalKey, key);
      if (!isNil(value)) ls.set(storeKey, value);
    });
  },

  get(globalKey, options) {
    forIn(options, (value, key) => {
      const storeKey = getStoreKey(globalKey, key);
      const storeValue = ls.get(storeKey);
      if (!isNil(storeValue) && storeValue !== value) Vue.set(options, key, storeValue);
    });
  },

  remove(globalKey) {
    return ls.removeByGlobalKey(snakeCase(globalKey));
  },
};

export { LocalStoreOptions };




// WEBPACK FOOTER //
// ./src/services/local-store-options.js